import React, { useEffect, useState } from 'react'
import { Navigate, Route, Routes } from "react-router-dom";
import { Preloader } from '../components/Preloader';
import { Routess } from './routes';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Navbar';
import PrivateRoute from './PrivateRoute';
import { useAuth } from '../store/AuthContext';
import { useIsMobile } from '../helpers/useIsMobile';
const HomeRoute = () => {
  const protectedRoutes = Object.values(Routess);

  return (
    <Routes>
      <Route path={Routess.Login.path} element={<RouteWithLoader element={Routess.Login.component} />} />
      <Route path={Routess.NotFound.path} element={<RouteWithLoader element={Routess.NotFound.component} />} />
      <Route path={Routess.ServerError.path} element={<RouteWithLoader element={Routess.ServerError.component} />} />
      {protectedRoutes.map(({ path, component, permission }, index) => (
        <Route
          key={index}
          element={<PrivateRoute requiredPermission={permission} />}
        >
          <Route path={path} element={<RouteWithSidebar element={component} />} />
        </Route>
      ))}
      {/* Fallback route for unmatched paths */}
      <Route path="*" element={<Navigate to={Routess.NotFound.path} replace />} />
    </Routes>

  )
}



const RouteWithLoader = ({ element }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Preloader show={!loaded} />
      {loaded && element}
    </>
  );
};

const RouteWithSidebar = ({ element }) => {
  const [loaded, setLoaded] = useState(false);
  const { isSidebarCollapsed, setIsSidebarCollapsed } = useAuth();
  const isMobile = useIsMobile(); // detects <768px
  const effectiveCollapsed = isMobile || isSidebarCollapsed;
  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);


  return (
    <>
      <Preloader show={!loaded} />
      <Sidebar />

      <Topbar />
      {isMobile && !isSidebarCollapsed && (
        <div
          onClick={() => setIsSidebarCollapsed(true)}
          className="fixed inset-0 bg-black/50 z-40 backdrop-blur-sm transition-opacity"
        />
      )}
      <main className="min-h-screen pt-[70px] bg-light transition-all duration-300 ease-in-out" style={{
        marginLeft: effectiveCollapsed ? 0 : 256,
      }}>
        <div className="p-4 md:p-6">
          {loaded && element}
        </div>
      </main>
    </>
  );
};

export default HomeRoute